import { useCallback, useEffect, useRef, useState } from "react";
import { getContractStats } from "../setup/api/services/stats";

const useGetContractStats = (
  id?: number | string,
  organizationCode?: string,
  enabled = true
) => {
  const [data, setData] = useState<any>({});
  const [totalCount, setTotalCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);

  // Request ID to ignore stale responses
  const requestIdRef = useRef(0);

  const fetchContractStats = useCallback(async () => {
    // We'll pass parameters as-is to the API
    // No need to check availability - API can handle undefined params

    const requestId = ++requestIdRef.current;
    setLoading(true);

    try {
      const response = await getContractStats(id, organizationCode);

      // Ignore stale responses
      if (requestId !== requestIdRef.current) return;

      if (response?.data) {
        const values = response.data.statusCount.reduce(
          (
            acc: Record<string, { count: number; totalAmount: number }>,
            { status, count, totalAmount }
          ) => {
            acc[status] = { count, totalAmount };
            return acc;
          },
          {}
        );

        setData(values);
        setTotalCount(response.data.availableContractsCount);
      }
    } catch (error) {
      if (requestId === requestIdRef.current) console.error(error);
    } finally {
      if (requestId === requestIdRef.current) setLoading(false);
    }
  }, [id, organizationCode]);

  useEffect(() => {
    if (enabled) fetchContractStats();
  }, [fetchContractStats, enabled]);

  return {
    data,
    totalCount,
    loading,
  };
};

export default useGetContractStats;
